import React from 'react';
import { ContactTypes } from '../../schema/enum/contact-types';
import Icon from '../icon/icon';

export interface ContactLinkProps {
    contactType: string;
    value: string;
    description: string;
    displayText?: string;
    iconName?: string;
    className?: string;
}

const ContactLink = (props: ContactLinkProps & React.HTMLAttributes<HTMLAnchorElement>): React.ReactElement => {
    const { contactType, value, description, displayText, iconName, className, ...rest } = props;

    const linkPrefix: string = contactType === ContactTypes.EMAIL_ADDRESS ? 'mailto:' : 'tel:';

    return (
        <a href={`${linkPrefix}${value}`} title={description} className={'inline-flex items-center align-top '.concat(className || '')} {...rest}>
            {
                iconName ? <Icon name={iconName} className="fill-current mr-2" style={{ height: '1.5em', width: '1.5em' }} /> : null
            }
            {displayText || value}
        </a>
    );
};

export default ContactLink;
